import { render, staticRenderFns } from "./VideoTowerOptions.vue?vue&type=template&id=8c8c8924"
import script from "./VideoTowerOptions.vue?vue&type=script&lang=ts"
export * from "./VideoTowerOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports